import { render, staticRenderFns } from "./SubLicenceTable.vue?vue&type=template&id=21bea43a&scoped=true"
import script from "./SubLicenceTable.vue?vue&type=script&lang=js"
export * from "./SubLicenceTable.vue?vue&type=script&lang=js"
import style0 from "./SubLicenceTable.vue?vue&type=style&index=0&id=21bea43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bea43a",
  null
  
)

/* custom blocks */
import block0 from "./SubLicenceTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports